var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinIcon = function SvgCoinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "M2.488 9.004c.224-.274.337-.412.446-.372s.109.229.108.61v.014a8.2 8.2 0 0 0 8.202 8.202h.014c.38 0 .571-.001.61.108.04.11-.098.222-.372.446a6.401 6.401 0 0 1-9.008-9.008"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "M4.375 8.833a7.292 7.292 0 1 1 14.583 0 7.292 7.292 0 0 1-14.583 0"
  })));
};
export default SvgCoinIcon;